import { useGetMyDetailsQuery } from "Services/Admin";

export const useMyProfile = () => {
  const { data: userDetails, isLoading: isUserDetailsLoading } = useGetMyDetailsQuery();

  return {
    userDetails,
    isUserDetailsLoading,
  };
};
